<!--MENÚ CONTEXTUAL OCULTO -->
<div id="menuIzq" style="position: fixed;" [style.left]="menuTopLeftPosition.x" [style.top]="menuTopLeftPosition.y"
  [matMenuTriggerFor]="rightMenu">
  <!-- standard material menu -->
  <mat-menu #rightMenu="matMenu">
    <ng-template matMenuContent let-item="item">

      <button mat-menu-item (click)="deleteArchivo()">
        <mat-icon class="iconoMenVer" [ngStyle]="{'color':'grey'}">delete</mat-icon>
        {{ 'gestion.seguimiento.actas.eliminar' | translate }}
      </button>
    </ng-template>
  </mat-menu>
</div>

<app-esqueleto-tableros>
  <div titulo class="encabezadosSeparacion"
    [matTooltip]="('menu.'+ dataService.moduleSelect | translate) +' &bull; '+ ('menu.'+ dataService.subModuleSelect | translate)"
    [appOverflowTooltip]="('menu.'+ dataService.moduleSelect | translate) +' &bull; '+ ('menu.'+ dataService.subModuleSelect | translate)">
    <span class="headerCintilla1">{{ "menu." + dataService.moduleSelect | translate }}</span>
    <span class="bullSeparation">&bull;</span>
    <span class="headerCintilla2">{{ "menu." + dataService.subModuleSelect | translate }}</span>
  </div>

  <app-filters filtros
    [name]="'filtros.per' | translate"
    [array]="aniosDisponibles"
    [typeFilter]="Filters.PERIOD"
    (eventClick)="cambioAnio($event)"
  />
  <app-filters filtros
    [name]="'filtros.lider' | translate"
    [array]="responsablesActas" [typeFilter]="Filters.SUCURSALES"
    [click]="false" [consolidado]="selecAllResActas"
    (eventClick)="cambioLider($event)"
  />
  <app-filters filtros
    [name]="'filtros.res' | translate"
    [array]="responsablesActividadesActas" [typeFilter]="Filters.SUCURSALES"
    [click]="false" [consolidado]="selecAllResActiv"
    (eventClick)="cambioResponsable($event)"
  />

  <div borrador [ngStyle]="{'color':'gray'}"
    (click)="borrarFiltro()" class="iconoMen" matTooltip="{{'tooltips.borrar-filtros'|translate}}">
      <img src="./../../../../assets/img/eraser.png">
  </div>

  <div contenido class="zonaClass">
    <app-contenedor-elementos [header]="{
      title: ''
    }">

      <mat-icon iconos class="iconoMen" [ngStyle]="{'color':'gray'}"
        [matMenuTriggerFor]="menu2">more_vert</mat-icon>
      <mat-menu #menu2="matMenu">

        <button (click)="exportarExcel()" class="mat-menu-item" mat-menu-item class="w3-caja-menu">
          <mat-icon [ngStyle]="{'color':'gray'}">description</mat-icon>
          <span>{{ 'gestion.seguimiento.actas.exportar' | translate }}</span>
        </button>
      </mat-menu>

      <div body class="tabla">
        @if(!mostabla) {
          <app-skeleton-table/>
        }
        @if(mostabla) {
          <table class="tabla-aleema">
            <thead>
              <tr>
                <th class="w3-center" style="max-width: 3vw; min-width: 3vw;">
                  @if(mostrarAllActas) {
                  <mat-icon (click)="mostrarTodasLasActas()" class="iconoMen"
                    matTooltip="{{ 'gestion.seguimiento.actas.ocultarTodo' | translate }}"
                    matTooltipPosition="left">expand_less</mat-icon>
                  }
                  @if(!mostrarAllActas) {
                  <mat-icon (click)="mostrarTodasLasActas()" class="iconoMen"
                    matTooltip="{{ 'gestion.seguimiento.actas.mostrarTodo' | translate }}"
                    matTooltipPosition="left">expand_more</mat-icon>
                  }
                </th>
                <th (click)="ordenamientoTabla()" class="textoOverFlow anchosColumnasTit" style="width: 15vw;">
                  {{ 'gestion.seguimiento.actas.actas' | translate }}
                  @switch (ordenamiento) {
                    @case ('id') {<mat-icon class="iconoSortIni">sort_by_alpha</mat-icon>} 
                    @case ('asc') {<mat-icon class="iconoSortIni">vertical_align_bottom</mat-icon>} 
                    @case ('des') {<mat-icon class="iconoSortIni">vertical_align_top</mat-icon>}
                  }
                </th>
                <th class="anchosColumnas">
                  {{ 'gestion.seguimiento.actas.verActa' | translate }}
                </th>
                <th class="anchosColumnas">
                  {{ 'gestion.seguimiento.actas.inicio' | translate }}</th>
                <th class="anchosColumnas">
                  {{ 'gestion.seguimiento.actas.fin' | translate }}</th>
                <th class="anchosColumnasRes">
                  {{ 'gestion.seguimiento.actas.liderResponsable' | translate }}</th>
                <th class="anchosColumnas">
                  {{ 'gestion.seguimiento.actas.planeado' | translate }} </th>
                <th class="anchosColumnas borderDer">
                  {{ 'gestion.seguimiento.actas.ejecutado' | translate }} </th>
                <th class="anchosColumnas borderDer">
                  {{ 'gestion.seguimiento.actas.validacion' | translate }} </th>
                @if(actasMostrar.length != 0) {
                  @for(ad of adicionales; track ad.id; let i = $index) {
                    <th class="anchosColumnas">
                      {{ad.name}}
                    </th>
                  }
                }
              </tr>
            </thead>
            @for(actas of actasMostrar; track actas.id) {
            <tbody>
              <tr>
                <td class="w3-center" style="max-width: 3vw; min-width: 3vw; ">
                  @if(actas.check) {
                  <mat-icon (click)="mostrarActas(actas)" class="iconoMen"
                    [ngStyle]="{'color':'gray'}">expand_less</mat-icon>
                  }
                  @if(!actas.check) {
                  <mat-icon (click)="mostrarActas(actas)" class="iconoMen"
                    [ngStyle]="{'color':'gray'}">expand_more</mat-icon>
                  }
                </td>
                <td class="textoOverFlow" style="font-weight: bold;">
                  <span matTooltip="{{actas.nombre}}">{{actas.nombre}}</span>
                </td>
                <td class="w3-center">
                  @if(actas.acta !== null) {
                    <mat-icon class="iconoMen"
                      matTooltip="{{actas.acta.split('-')[actas.acta.split('-').length-1]}}"
                      (click)="abrirArchivo(actas)" [ngStyle]="{'color':'#4E9AC7'}">attach_file
                    </mat-icon>
                  }
                  @if(actas.acta === null) {
                    <mat-icon class="iconoMen" [ngStyle]="{'color':'#C8C7C8'}">attach_file</mat-icon>
                  }
                </td>
                <td class="w3-center">
                  {{obtFecha(actas.fecha_ini)}}</td>
                <td class="w3-center">
                  {{obtFecha(actas.fecha_fin)}}</td>
                <td class="w3-center">{{actas.responsable.position}}</td>
                <td>{{escribirDatPro(actas,'plan')}}</td>
                <td [ngClass]="pintarBordPro(escribirDatPro(actas, 'ejec'),escribirDatPro(actas, 'plan'))">
                  {{escribirDatPro(actas,'ejec')}}</td>
                <td class="anchosColumnas w3-center"><br></td>
                @if(actas.actividades.length !== 0) {
                  @for(ad of actas.actividades[0].adicionales; track ad.id; let i = $index) {
                    <td class="textoOverFlow" style="min-width: 5vw; max-width: 20vw;">
                      {{escribirAdicionalPro(actas.actividades,i)}}
                    </td>
                  }
                }
                @if(actas.actividades.length === 0) {
                  @for(ad of adicionales; track ad.id; let i = $index) {
                    <td class="textoOverFlow" style="min-width: 5vw; max-width: 20vw;">
                      <br>
                    </td>
                  }
                }
              </tr>
              @if(actas.check) {
                @for(act of actas.actividades; track act.id) {
                  @if(existAct(act)) {
                    <tr>
                      <td style="min-width: 1vw; padding: 0vh;"><br>
                      </td>
                      <td class="anchosColumnas textoOverFlow" matTooltip="{{act.nombre}}">
                        {{act.nombre}}
                      </td>
                      <td><br></td>
                      <td class="w3-center">
                        {{obtFecha(act.fecha_inicio)}}</td>
                      <td class="w3-center">
                        {{obtFecha(act.fecha_fin)}}</td>
                      <td class="w3-center textoOverFlow">
                        {{act.responsable.position}}</td>
                      <td>{{escribirDat(act.history,'plan')}}</td>
                      <ng-container *appRoles="permisos.SEGUIMIENTO">
                        @if(escribirDat(act.history, 'ejec') === 0 ||
                        escribirDat(act.history, 'ejec') === null) {
                        <td [ngClass]="pintarBord(escribirDat(act.history, 'ejec'),escribirDat(act.history, 'plan'))"
                          (dblclick)="editar(act.history, act.id)">
                          0
                        </td>
                        }
                        @if(escribirDat(act.history, 'ejec') !== 0 &&
                        escribirDat(act.history, 'ejec') !== null) {
                        <td [ngClass]="pintarBord(escribirDat(act.history, 'ejec'),escribirDat(act.history, 'plan'))"
                          (dblclick)="editar(act.history, act.id)">
                          {{escribirDat(act.history, 'ejec')}}
                        </td>
                        }
                      </ng-container>
                      <ng-container *appRolesNeg="permisos.SEGUIMIENTO">
                        @if(escribirDat(act.history, 'ejec') === 0 || escribirDat(act.history, 'ejec') === null) {
                          <td [ngClass]="pintarBord(escribirDat(act.history, 'ejec'),escribirDat(act.history, 'plan'))">
                            0
                          </td>
                        }
                        @if(escribirDat(act.history, 'ejec') !== 0 && escribirDat(act.history, 'ejec') !== null) {
                          <td [ngClass]="pintarBord(escribirDat(act.history, 'ejec'),escribirDat(act.history, 'plan'))">
                            {{escribirDat(act.history, 'ejec')}}
                          </td>
                        }
                      </ng-container>
                      <td class="anchosColumnas w3-center">

                        @if(act.validacion !== null && act.validacion !== false) {
                        <mat-icon (click)="puedeValidar(actas.responsable, act)" class="iconoMen"
                          [ngStyle]="{'color':'#72D54A'}">done</mat-icon>
                        }
                        @if(act.validacion === null || act.validacion === false) {
                        <mat-icon (click)="puedeValidar(actas.responsable, act)" class="iconoMen"
                          [ngStyle]="{'color':'#C8C7C8'}">done</mat-icon>
                        }
                        @if(escribirDat(act.history, 'ejec') !== 100) {
                          <br>
                        }
                      </td>
                      @if(act.adicionales.length !== 0) {
                        @for(ad of act.adicionales; track $index) {
                          <ng-container *appRoles="permisos.SEGUIMIENTO">
                            @if(ad.type !== 'moneda' && ad.type !== 'archivo' && ad.type !== 'numero') {
                              <td class="textoOverFlow" matTooltip="{{escribirAdicional(ad)}}"
                              (dblclick)="edicionAd(ad, act.id, $event)">
                                {{escribirAdicional(ad)}}
                              </td>
                            }
                          </ng-container>
                          <ng-container *appRolesNeg="permisos.SEGUIMIENTO">
                            @if(ad.type !== 'moneda' && ad.type !== 'archivo' && ad.type
                            !== 'numero') {
                              <td class="textoOverFlow" matTooltip="{{escribirAdicional(ad)}}">
                                {{escribirAdicional(ad)}}
                              </td>
                            }
                          </ng-container>
                          @if(ad.type === 'moneda') {
                            <td class="alinDer">
                              <span matTooltip="{{escribirAdicional(ad)}}">{{escribirAdicional(ad)}}</span>
                            </td>
                          }
                          @if(ad.type === 'numero') {
                            <td class="alinIzq">
                              <span matTooltip="{{escribirAdicional(ad)}}">{{escribirAdicional(ad)}}</span>
                            </td>
                          }
                          @if(ad.type === 'archivo') {
                            <td class="textoOverFlow w3-center">
                              <div *appRoles="permisos.SEGUIMIENTO">
                                @if(escribirAdicional(ad) !== '') {
                                <div (click)="abirPDF(ad, $event);"
                                  (contextmenu)="onContextMenu($event, ad, act)">
                                  <mat-icon matTooltip="{{escribirAdicional(ad)}}" class="iconoMen"
                                    [ngStyle]="{'color':'#4E9AC7'}">attach_file</mat-icon>
                                </div>
                                }
                                @if(escribirAdicional(ad) === '') {
                                <div (dblclick)="edicionAd(ad, act.id, $event)">
                                  <mat-icon matTooltip="{{ 'gestion.seguimiento.actas.adjuntarArchivo' | translate }}"
                                  [ngStyle]="{'color':'#C8C7C8'}" class="iconoMen">attach_file</mat-icon>
                                </div>
                                }
                              </div>
                              <div *appRolesNeg="permisos.SEGUIMIENTO">
                                @if(escribirAdicional(ad) !== '') {
                                <div (click)="abirPDF(ad, $event);">
                                  <mat-icon matTooltip="{{escribirAdicional(ad)}}" class="iconoMen"
                                    [ngStyle]="{'color':'#4E9AC7'}">attach_file</mat-icon>
                                </div>
                                }
                                @if(escribirAdicional(ad) === '') {
                                <div>
                                  <mat-icon class="iconoMen" [ngStyle]="{'color':'#C8C7C8'}">attach_file</mat-icon>
                                </div>
                                }
                              </div>
                            </td>
                          }
                        }
                      }
                    </tr>
                  }
                }
              }
            </tbody>
            }
          </table>
        }
      </div>

    </app-contenedor-elementos>
  </div>
</app-esqueleto-tableros>